exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".debt-account-modal {\n    font-size: 16px;\n}\n\n.modal-body {\n    width: 90%;\n    margin: 0 auto;\n}\n\ninput[type=\"radio\"] {\n    margin-bottom: 30px;\n}\n\n#saveAccount {\n    margin-top: 20px;\n}\n\n#newDebtAccount {\n    padding-right: 60px;\n}\n\n.icons {\n    position: absolute;\n    bottom: 92px;\n    right: 25px;\n}\n\n.icons i {\n    margin-left: 10px;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/client-status/account-modal/account-modal.component.css
// module id = 1209
// module chunks = 9